import { IAbcComponent, StylingMode } from '../abcComponent.model';

export interface ISelectBox extends IAbcComponent {
  id: string;
  dataSource: any[];
  disabled: boolean;
  value: any;
  valueExpr: string;
  items: string[];
  placeholder: string;
  showClearButton: boolean;
  readOnly: boolean;
  displayExpr: string;
  stylingMode?: StylingMode;
  hoverStateEnabled?: boolean;
  height: string;
  width: string;
  visible?: boolean;
  validationStatus?: ValidationStatus;
  showDropDownButton?: boolean;
  showSelectionControls?: boolean;
  rtlEnabled?: boolean;
  acceptCustomValue?: boolean;
  searchMode?: SelectBoxSearchMode;
  searchExpr?: string[];
  searchTimeout?: number;
  searchEnabled?: boolean;
  specificTemplate?: boolean;
}

export enum StylingSelectMode {
  Underlined = 'underlined',
  Outlined = 'outlined',
  Filled = 'filled',
}

export enum ValidationStatus {
  Valid = 'valid',
  Invalid = 'invalid',
  Pending = 'pending',
}
export enum SelectBoxSearchMode {
  Contains = 'contains',
  StartsWith = 'startswith',
}
